<template>
    <section class="p-5 card log-panel col-md-4 offset-md-4 col-10 offset-1 mt-md-0 mt-1">
        <h5 class="text-center">التقارير المالية</h5>
        <form @submit.prevent="getReport" class=" my-3">
            <div class="mb-3">
                <label for="from" class="form-label">من : </label>
                <input type="date" v-model="searchData.from" id="from" class="form-control" placeholder=""
                    aria-describedby="from-date" />
                <small id="from-date" class="text-muted">من تاريخ</small>
            </div>
            <div class="mb-3">
                <label for="to" class="form-label">إلى : </label>
                <input type="date" v-model="searchData.to" id="to" class="form-control" placeholder=""
                    aria-describedby="to-date" />
                <small id="to-date" class="text-muted">إلى تاريخ</small>
            </div>
            <div class="container justify-content-center">
                <div class="form-check form-check-inline">
                    <input v-model="searchData.status" class="form-check-input" type="radio" id="search-receipt" value="1"
                        checked @change="resetValues()" />
                    <label class="form-check-label" for="search-receipt">إيصالات الخدمات الرقمية</label>
                </div>
                <div class="form-check form-check-inline">
                    <input v-model="searchData.status" class="form-check-input" type="radio" id="search-daily" value="2"
                         @change="resetValues()" />
                    <label class="form-check-label" for="search-daily">الإجمالي اليومي</label>
                </div>

                <div class="" v-if="(getUser?.departId == 1)">
                    <label for="departId" class="form-label">المركز الجمركي</label>
                    <select class="form-select" id="departId" v-model="searchData['departId']" @change="resetValues()"
                        required="required">
                        <option value="" data-hidden="true" selected disabled>
                            اختر المركز الجمركي
                        </option>
                        <option v-for="depart in departs" :key="depart.id" :value="depart.id">
                            {{ depart.name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="container justify-content-center">
                <div class="form-check form-check-inline">
                    <input v-model="searchData.appType" class="form-check-input" type="radio" id="search-export"
                        value="1" @change="resetValues()" />
                    <label class="form-check-label" for="search-export">التصدير المؤقت</label>
                </div>
                <div class="form-check form-check-inline">
                    <input v-model="searchData.appType" class="form-check-input" type="radio" id="search-import"
                        value="2" @change="resetValues()" />
                    <label class="form-check-label" for="search-import">الاستيراد المؤقت</label>
                </div>
                <div class="form-check form-check-inline">
                    <input v-model="searchData.appType" class="form-check-input" type="radio" id="search-any" value="0"
                        @change="resetValues()" />
                    <label class="form-check-label" for="search-any">الكل</label>
                </div>
            </div>
            <div class="d-flex justify-content-between mt-2">
                <button class="btn btn-primary " type="submit">بحث</button>
                <button @click="$router.go(-1)" class="btn btn-secondary " type="button">عودة
                    <font-awesome-icon icon="fa-regular fa-circle-left" />
                </button>
            </div>
            <!-- <button class="btn btn-secondary mt-2 offset-10" type="submit">بحث</button> -->
        </form>
    </section>

    <ReceiptsReport v-if="searchData.status == 1" :reportData="reportData" :depart="departs.find(e => e.id === reportData.departId)?.name"/>
    <DailyIncomeReport v-else :reportData="reportData" :depart="departs.find(e => e.id === reportData.departId)?.name"/>
</template>

<script>
import GeneralModal from "@/components/Modal.vue";
import AlertModal from "@/components/AlertModal.vue";
import { mapGetters, mapActions } from 'vuex';
// import GeneralTable from "@/components/GeneralTable.vue";
import DailyIncomeReport from "@/components/FinancialReports/DailyIncomeReport.vue";
import ReceiptsReport from "@/components/FinancialReports/ReceiptsReport.vue";
export default {
    name: "financialReport",
    components: {
        GeneralModal,
        AlertModal,
        DailyIncomeReport,
        ReceiptsReport,
    },
    data() {
        return {
            searchData: {
                from: null,
                to: null,
                status: 1,
                appType: 0,
                pageNo: 1,
                pageSize: 25,
            },
            departs: [],
            reportData: [],
            // subjects: ['رقم الإيصال', 'رقم التسجيل ', 'اسم المتقدم', 'رقم الهاتف', 'رقم الجواز', 'نوع المركبة', 'قيمة الإيصال', 'نوع الطلب', 'حالة الطلب', 'تاريخ الإيصال']
            
            // keyDateText: ["", "التقديم", "المغادرة", "العودة"]
        }
    },
    async created() {
        this.setDates();
        await this.fetchOptions();
    },
    computed: {
        ...mapGetters(['getUser', 'getDeparts']),
        currentCountInView: function () {
            return this.searchData?.pageSize * this.searchData?.pageNo;
        }
    },
    methods: {
        /** */
        ...mapActions([
            'fetchUser',
            'fetchDeparts'
        ]),
        /********************************/
        /* */
        setDates(){
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = currentDate.getMonth();
            const day = currentDate.getDate();
            const monthAgoDate = new Date(year, month - 1 , day + 1);
            // If the day rolled over to the next month (e.g., Feb 31 becomes Mar 2), fix it
            if(monthAgoDate.getMonth() === month) {
                monthAgoDate.setDate(1);
            }
            this.searchData.from = monthAgoDate.toISOString().split('T')[0]
            this.searchData.to = currentDate.toISOString().split('T')[0];
        },
        /********************************/
        /* */
        async fetchOptions() {
            if (this.getDeparts.length == 0) {
                await this.fetchDeparts();
            }
            if (this.getUser.hasOwnProperty("empNo") == 0) {
                await this.fetchUser();
            }
            this.departs = (this.getDeparts[0].id == 1) ? this.getDeparts.slice(1) : this.getDeparts;
        },
        /********************/
        /* */
        resetValues() {
            this.reportData = [];
            this.searchData.pageNo = 1;
        },
        /********************/

        // Fetch the report data with pagination for each section
        async getReport() {
            this.searchData.pageNo = 1;
            try {
                const response = await this.$axios.post((this.searchData.status == 1) ? `api/employee/report/getreceipts` : `api/employee/report/getdailyincome`, this.searchData);

                if (response?.data && response?.data.isSuccess) {
                    // Update the reportData with pagination information for each section
                    this.reportData = response.data.data;
                    // كان هكذا قبل إضافة خيار المعبر الحدودي لمدير النظام
                    // this.reportData = response.data.data.map(section => ({
                    //     ...section,
                    //     pageNo: section.pageNo || 1,
                    //     totalPages: section.totalPages || 1,
                    // }));
                } else {
                    this.$tempAlert(response?.data.msg ?? "حدثت مشكلة", 'warning');
                    this.reportData = [];
                }
            } catch (error) {
                console.error("Error fetching report:", error);
                if (error.response?.data) {
                    this.$tempAlert(error.response.data.msg, 'warning');
                }
            }
        },


        // Change the current page for a specific report section
        changePage(reportAppSection, newPageNo) {
            if (newPageNo >= 1 && newPageNo <= reportAppSection.totalPages) {
                reportAppSection.pageNo = newPageNo;
                this.getReportForSection(reportAppSection);
            }
        },

        // Fetch the report for a specific section based on the page number
        async getReportForSection(reportAppSection) {
            this.searchData.pageNo = reportAppSection.pageNo
            try {
                const response = await this.$axios.post((this.searchData.status == 1) ? `api/employee/report/getreceipts` : `api/employee/report/getdailyincome`, this.searchData);
                this.reportData = response.data.data;
               } catch (error) {
                console.error("Error fetching report for section:", error);
            }
        },

        // Fetch the report as a pdf file
        async printPdf() {
            this.searchData.pageNo = 1;
            try {
                const response = await this.$axios.post( (this.searchData.status == 1) ? `api/employee/report/getreceipts/print` : `api/employee/report/getdailyincome/print`, this.searchData,
                    {
                        responseType: 'blob',
                    });

                console.log(response)

                const blob = new Blob([response.data], { type: 'application/pdf' })
                const url = window.URL.createObjectURL(blob)

                // Open in a new tab
                window.open(url, '_blank')

                // Optional cleanup (after some delay to let the file load)
                setTimeout(() => {
                    window.URL.revokeObjectURL(url)
                }, 100)
            } catch (error) {
                console.error("Error fetching report:", error);
                if (error.response?.data) {
                    this.$tempAlert(error.response.data.msg, 'warning');
                }
            }
        },
    }
}
</script>
